import { render, staticRenderFns } from "./ItemProdutoList.vue?vue&type=template&id=4e8f1062&scoped=true&"
import script from "./ItemProdutoList.vue?vue&type=script&lang=js&"
export * from "./ItemProdutoList.vue?vue&type=script&lang=js&"
import style0 from "./ItemProdutoList.vue?vue&type=style&index=0&id=4e8f1062&prod&lang=scss&scoped=true&"
import style1 from "./ItemProdutoList.vue?vue&type=style&index=1&id=4e8f1062&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8f1062",
  null
  
)

export default component.exports